import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit des saisies</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet d'avocats GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers en
					matière de recouvrement de créances, de saisie et de procédure d'exécution (par huissier).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si quelqu'un vous doit de l'argent, légitimement, vous désirez le récupérer. Le cabinet vous aidera
					dans les démarches, et si nécessaire la procédure judiciaire, destinées à recouvrer votre créance, à
					obtenir paiement. Le cabinet vous assistera également si vous désirez combattre une demande de
					paiement que vous estimez injuste.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					En <strong>droit des saisies</strong>, le cabinet intervient tant pour le créancier que pour le
					débiteur en matière de recouvrement des créances, de vente judiciaire immobilière ou de saisie
					conservatoire ou exécution par huissier de justice.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Plus généralement, le cabinet vous aidera dans la mesure du possible en matière de saisie sur
					salaire, saisie sur un compte bancaire, saisie ou commandement sur une maison ou un autre immeuble…
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Poursuites contre un débiteur
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Saisie de votre maison
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Saisie sur votre salaire
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
